import { render, staticRenderFns } from "./WorkCheckbox.vue?vue&type=template&id=5b36e612&scoped=true"
import script from "./WorkCheckbox.vue?vue&type=script&lang=js"
export * from "./WorkCheckbox.vue?vue&type=script&lang=js"
import style0 from "./WorkCheckbox.vue?vue&type=style&index=0&id=5b36e612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b36e612",
  null
  
)

export default component.exports